module.exports = function(lastTouchEvent, clickTimestamp) {
  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ../~/react-tap-event-plugin/src/defaultClickRejectionStrategy.js
// module id = 171
// module chunks = 0